import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import 'jodit/esm/plugins/clean-html/clean-html.js';
import 'jodit/esm/plugins/indent/indent.js';
import 'jodit/esm/plugins/video/video.js';

Error.stackTraceLimit = 100;
//enableProdMode();

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch(err => console.error(err));
